/**
* Now Playing Spotify component.
* @author Dayne Coulson-Hoffacker
*/
export default class NowPlaying {
  /**
  * Constructs a new Now Playing Spotify instance.
  * @param {Object} options - Options.
  * @param {HTMLElement} options.element - Container.
  */
  constructor (options) {
    this.element = options.element
    this.url = 'https://ws.audioscrobbler.com/2.0/?method=user.getrecenttracks&user=weareduo&api_key=0328add75e12d61d6dc3c309db6d055d&format=json&limit=2'

    let songDetails= this.element.querySelector('.song-details')

    function createNode(element) {
      return document.createElement(element)
    }

    function append(parent, el) {
      return parent.appendChild(el)
    }

    fetch(this.url)
    .then((resp) => resp.json())
    .then(function(data) {
      var counter = 1
      let tracks = data.recenttracks.track
      return tracks.map(function(track) {
        if (counter == 1) {
          let artist = createNode('div.artist')
          artist.innerHTML = `${track.artist['#text']} — ${track.name}`
          append(songDetails, artist)
        }
        counter++
      })
    })
    .catch(function(error) {
      console.log(error)
    })

  }
}



// WEBPACK FOOTER //
// ./components/now-playing/index.js